import { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { EducationMaterialForm } from './components/education-material-form';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EducationMaterial } from '../../types/education-materials/education-material';
import { PartialBy } from '../../types/partial-by';
import { addEducationMaterial } from '../../store/education-materials/thunks';
import { DroppedFile } from '../../types/dropped-file';
import { initialValuesMaterialFormEntity } from '../../store/education-materials/types';
import { useLanguage } from '../../contexts/language/language-context';
// import { LanguageSwicher } from '../../components/language-switcher';

export const AddEducationMaterial = memo(() => {
  const { groupid } = useParams<{ groupid: string }>();
  const dispatch = useDispatch();
  const { currentLanguage,
    // setCurrentLanguage
  } = useLanguage();

  const onSubmit = useCallback(
    (values: { [key: string]: PartialBy<EducationMaterial, '_id' | 'file' | 'mimeType'> }, droppedFile: DroppedFile | null, customThumbnail: DroppedFile | null) => {
      dispatch(addEducationMaterial(
        groupid,
        values,
        droppedFile,
        customThumbnail,
        new URLSearchParams([
          ['lang', currentLanguage]
        ])
      ));
    },
    [currentLanguage, dispatch, groupid]
  );

  return (
    <div>
      <div className="d-flex justify-content-between">
        <ol className='breadcrumb mb-3'>
          <li className='breadcrumb-item'>
            <Link to={'/education-materials-groups'}>Estating Academy</Link>
          </li>
          <li className='breadcrumb-item active' aria-current='page'>
            create new
          </li>
        </ol>
        <div className="h-min">
          {/* <LanguageSwicher
            selectedLanguage={currentLanguage}
            availableLanguages={[
              { label: 'Default', value: 'en' },
              { label: 'Spanish', value: 'es' },
            ]}
            onLanguageSelect={setCurrentLanguage}
          /> */}
        </div>
      </div>

      <EducationMaterialForm initialValues={initialValuesMaterialFormEntity} onSubmit={onSubmit} />
    </div>
  );
});
